import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AdminLayout from '../../components/AdminLayout';
import ProductPicker from '../../components/admin/ProductPicker';
import { API, withCreds, btnPrimary, PageHeader, Spinner, money, errMsg } from '../../components/admin/AdminUI';
import { ArrowUp, ArrowDown, X, Check, Star, Package } from 'lucide-react';

export default function AdminFeatured() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/featured-products`, withCreds).then(r => setItems(r.data.products)).finally(() => setLoading(false));
  }, []);

  const update = (next) => { setItems(next); setDirty(true); setSaved(false); };
  const move = (i, dir) => {
    const next = [...items];
    [next[i], next[i + dir]] = [next[i + dir], next[i]];
    update(next);
  };
  const addIds = async (ids) => {
    const newIds = ids.filter(id => !items.some(p => p.id === id));
    const added = await Promise.all(newIds.map(id => axios.get(`${API}/admin/products/${id}`, withCreds).then(r => r.data)));
    update([...items, ...added]);
  };

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/featured-products`, { product_ids: items.map(p => p.id) }, withCreds);
      setDirty(false); setSaved(true);
    } catch (e) { alert(errMsg(e)); }
    finally { setSaving(false); }
  };

  return (
    <AdminLayout>
      <PageHeader title="Featured" subtitle="Hand-picked items shown in the Featured section of the home page, in this order">
        <button onClick={save} disabled={!dirty || saving} className={btnPrimary}>{saved ? <><Check className="w-4 h-4" /> Saved</> : saving ? 'Saving…' : 'Save order'}</button>
      </PageHeader>
      <div className="admin-card rounded-xl p-4 mb-4">
        <ProductPicker value={[]} onChange={addIds} filter={p => p.published} placeholder="Search published products to feature…" />
      </div>
      <div className="admin-card rounded-xl overflow-hidden">
        {loading ? <Spinner /> : items.length === 0 ? (
          <div className="text-center py-12"><Star className="w-8 h-8 text-ink/30 mx-auto mb-2" /><p className="text-ink/45 text-sm">Nothing featured yet.</p></div>
        ) : items.map((p, i) => (
          <div key={p.id} className="flex items-center gap-3 p-3 border-b border-ink/10 last:border-0">
            <span className="text-ink/45 text-sm w-6 text-right">{i + 1}</span>
            <div className="w-10 h-10 rounded-lg overflow-hidden bg-ink/[0.04] flex-shrink-0">
              {p.images?.[0] ? <img src={p.images[0]} alt="" className="w-full h-full object-cover" /> : <Package className="w-5 h-5 text-ink/30 m-auto mt-2.5" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-ink text-sm truncate">{p.title}</p>
              <p className="text-ink/55 text-xs">{money(p.price)}{!p.published && <span className="text-amber-600 ml-2">Draft: won't show until published</span>}</p>
            </div>
            <button onClick={() => move(i, -1)} disabled={i === 0} className="p-1 text-ink/55 hover:text-ink disabled:opacity-20"><ArrowUp className="w-4 h-4" /></button>
            <button onClick={() => move(i, 1)} disabled={i === items.length - 1} className="p-1 text-ink/55 hover:text-ink disabled:opacity-20"><ArrowDown className="w-4 h-4" /></button>
            <button onClick={() => update(items.filter(x => x.id !== p.id))} className="p-1 text-ink/55 hover:text-red-600"><X className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
